// extracted by mini-css-extract-plugin
export default {"MyLearningWidget":"MyLearningWidget_MyLearningWidget__OuK1v","DomainsList":"MyLearningWidget_DomainsList__FVgNW","LinkToAll":"MyLearningWidget_LinkToAll__rv9Hg"};